const prefix = '[massmessaging] ';

// modal
export const OPENMODAL = `${prefix}OPEN_MODAL`;
export const CLOSEMODAL = `${prefix}CLOSE_MODAL`;
export const SENDMESSAGE = `${prefix}SEND_MESSAGE`;
export const GETPARTNERS = `${prefix}GETPARTNERS`;



// WEBPACK FOOTER //
// ./src/app/components/massmessaging/store/constants.js